import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    color: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M7.366 15H9.98V8.952h1.827L12 6.922H9.98V5.77c0-.48.104-.672.61-.672H12V3h-1.812c-1.945 0-2.822.795-2.822 2.318v1.618H6v2.043h1.366z" fill="currentColor"/>' }
  })
);